import React, { useState, useEffect } from 'react';
import './ModifierGroup.scss';
import { menuSingleItemSelected } from '../helpers/menuHelpers';

import { ApplicationState } from '../store';
import { useSelector, useDispatch } from 'react-redux';
import * as menuItemStore from '../store/MenuItemStore';
import { bindActionCreators } from 'redux';

import 'react-slidedown/lib/slidedown.css'
import ModifierGroupItem from './ModifierGroupItem';

interface IModifierGroup {
    modifierGroup: IMopModifierGroup;
    onSelectedSingle?: (id: string) => void;
    localId: string;
    isColleague: boolean | null;
}

const ModifierGroup: React.FC<IModifierGroup> = ({ modifierGroup, localId, onSelectedSingle, isColleague }) => {
    const {
        groupTitle,
        groupDescription,
        canSelectMultiple,
        itemsAreChargeable,
        maxDifferentItems,
        modifierGroupItems,
        groupType
    } = modifierGroup;

    const isBasket = useSelector((state: ApplicationState) => state.menuItemData?.isBasket);
    const boundUpdateItem = bindActionCreators(menuItemStore.actionCreators.updateModifierGroupItem, useDispatch());

    const [selected, setSelected] = useState<string | undefined>();
    const [totalQuantitySelected, setTotalQuantitySelected] = useState<number>(0);

    /*
        onModifierGroupItemSelected
            if min is 1 (OR max met?), and it's the first time it's been changed (or totalSelected == max)
                tryOpenNextModifierGroup
                    if there is a next modifier group
                        move on to next
    */

    /*
        TODO:
        Group 10 - Radio - DONE
        Group 20 - Quantity No Checkbox ChargeableExtras
        Group 30 - Checkbox Customisations
        Group 40 - Quantity with Checkbox Swaps -
        Group 50 - Extras

    */

    useEffect(() => {
        var startSelected = menuSingleItemSelected(modifierGroup, isBasket as boolean);  //Pass through isBasketUpdate flag to decide whether to check defaultQuantitySelected or quantitySelected
        setSelected(startSelected);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (groupType === 10) { //Only perform this check if it's a radio group modifier, could use maxDifferentItems instead
            let menuItem: IMopModifierGroupItem = modifierGroupItems.find((item: IMopModifierGroupItem) => item.menuItemName == selected);
            let prevItem: IMopModifierGroupItem = modifierGroupItems.find((item: IMopModifierGroupItem) => item.quantitySelected == 1);

            //console.log("Selected", selected, menuItem, prevItem, "isBasket", isBasket, "isColleague", isColleague);
            //console.log(`D: Selected: ${selected}, menuItem: ${menuItem?.menuItemName}, prevItem: ${prevItem?.menuItemName}`);

            if (menuItem) {
                handleChange(menuItem, 1);
                if (prevItem && prevItem.menuItemId !== menuItem.menuItemId) {
                    handleChange(prevItem, 0);
                    //console.log(menuItem, prevItem);
                    onSelectedSingle && onSelectedSingle(localId);
                }
                else {
                    if (!isBasket && menuItem.defaultQuantitySelected > 0) {
                        //Program selected this option.
                    }
                    else if (isBasket && menuItem.quantitySelected > 0) {
                        //Program selected this option.
                    }
                    else {
                        onSelectedSingle && onSelectedSingle(localId);
                    }
                }
            }
        }
    }, [selected])

    // Max Quantity Handler
    useEffect(() => {
        const total = modifierGroupItems.reduce((total: number, currentValue: IMopModifierGroupItem) => (
            total += currentValue.quantitySelected
        ), 0);

        setTotalQuantitySelected(total);
    }, [modifierGroupItems]);

    const handleChange = (menuItem: IMopModifierGroupItem, quantity: number) => {
        //console.log("Updating menu item in group at ", menuItem.menuItemId, "Quantity = ", quantity);
        boundUpdateItem(menuItem.menuItemId, quantity);
    }

    return (
        <div className="ion-no-padding modifierGroup">
            <>
                <div className="ProductOptionBanner">
                    {groupTitle &&
                        <div className="ProductOptionBannerTitle">
                            <p>
                                {groupTitle}
                                {groupType === 10 &&
                                    <span className='red'>*</span>
                                }
                            </p>
                        </div>
                    }
                    <div className="ProductOptionBannerDescription">
                        <p>
                            {groupDescription}
                            {!groupTitle && groupType === 10 &&
                                <span className='red'>*</span>
                            }
                        </p>
                    </div>
                </div>
                <div>
                    {
                        modifierGroupItems?.map((mgi: IMopModifierGroupItem) => {
                            return (
                                <ModifierGroupItem
                                    key={`mgi_${mgi.menuItemId}`}
                                    inStock={mgi.inStock}
                                    canSelectMultiple={groupType !== 10}
                                    showPrice={itemsAreChargeable}
                                    showImage={modifierGroup.showImages}
                                    showQuantityComponent={(groupType === 20 || groupType === 40 || groupType === 50) && mgi.quantitySelected > 0}
                                    menuItem={mgi}
                                    onSelect={setSelected}
                                    onChange={handleChange}
                                    disableSelect={
                                        maxDifferentItems > 0
                                        && totalQuantitySelected >= maxDifferentItems
                                        && mgi.quantitySelected < 1
                                    }
                                    disableAddQuantityButton={
                                        (totalQuantitySelected >= maxDifferentItems && maxDifferentItems > 0)
                                        || (mgi.maxQuantity != null && totalQuantitySelected >= mgi.maxQuantity)
                                    }
                                />
                            )
                        })
                    }
                </div>
            </>
        </div>
    );
};

export default ModifierGroup;

// NOTE: Dropdown for when we have a flag for it. - Fletcher 2024-04-20
//<>
//    <IonItem className="ModifierGroup-Dropdown__item" lines="none" onClick={() => { onToggleDropdown(!isDropdownOpen, localId); }}>
//        <div style={{
//            backgroundColor: "inherit",
//            color: "inherit"
//        }} className={`ModifierGroup-Dropdown__header ${totalQuantitySelected > 0 ? "selected" : ""}`}>
//            <p>DROPDOWN?</p>
//            <div className="Dropdown-Label__container">
//                {
//                    totalQuantitySelected > 0
//                        ?
//                        <div className="Dropdown-Label__selected">
//                            <div className="Dropdown-Selected__title">{auxData?.name ? auxData.name + ": " : ""}Click to change</div>
//                            <div className="Dropdown-Selected__choice">
//                                {
//                                    chosenItems.map((chosen, i) => {
//                                        /*
//                                            chosen += chosen == "" ? "" : ", ";
//                                            chosen += `${item.quantitySelected > 1 ? item.quantitySelected + " x " : ""}${item.menuItemName}`;
//                                            */
//                                        let prefix = i > 0 ? ", " : "";
//                                        return <span><span>{prefix}</span><span dangerouslySetInnerHTML={{ __html: chosen }}></span></span>
//                                    })
//                                }
//                            </div>
//                        </div>
//                        :
//                        <div className="Dropdown-Label__default">{auxData.preSelectedTitle ? auxData.preSelectedTitle : auxData.name}</div>
//                }
//            </div>
//            {
//                isDropdownOpen
//                    ? <IonIcon icon={chevronUpOutline} />
//                    : <IonIcon icon={chevronDownOutline} />
//            }
//        </div>
//    </IonItem>
//    <SlideDown closed={!isDropdownOpen}>
//        {getModifierComponent(modifierGroupItems.length === 1)}
//    </SlideDown>
//</>
